import {ActionIcon, Group, Text, createStyles} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface InputsTablePagerProps {
  // Zero-based current page and total page count.
  page: number;
  pageCount: number;
  // One-based inclusive range of inputs shown on the current page, and the total input count.
  pageStartIndex: number;
  pageEndIndex: number;
  totalCount: number;
  onPrev: () => void;
  onNext: () => void;
}

/** Footer row for the inputs table: "Showing X–Y of Z" with Prev / Page N of M / Next controls. */
export default function InputsTablePager({
  page,
  pageCount,
  pageStartIndex,
  pageEndIndex,
  totalCount,
  onPrev,
  onNext,
}: InputsTablePagerProps): JSX.Element {
  const {classes} = useStyles();
  const isFirstPage = page <= 0;
  const isLastPage = page >= pageCount - 1;

  return (
    <div className={classes.footer}>
      <Text color="dimmed" size="sm">
        Showing {pageStartIndex}–{pageEndIndex} of {totalCount}
      </Text>
      <Group noWrap={true} spacing="sm">
        <ActionIcon aria-label="Previous page" disabled={isFirstPage} onClick={onPrev} variant="subtle">
          <BenchlingIcon icon="chevron-left" />
        </ActionIcon>
        <Text color="dimmed" size="sm">
          Page {page + 1} of {pageCount}
        </Text>
        <ActionIcon aria-label="Next page" disabled={isLastPage} onClick={onNext} variant="subtle">
          <BenchlingIcon icon="chevron-right" />
        </ActionIcon>
      </Group>
    </div>
  );
}

const useStyles = createStyles((theme) => ({
  footer: {
    alignItems: 'center',
    backgroundColor: theme.colors.gray[0],
    display: 'flex',
    justifyContent: 'space-between',
    padding: `${theme.spacing.xs} ${theme.spacing.md}`,
  },
}));
